var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"transition duration-500 ease-in m-auto rounded-full h-5 w-5 flex items-center justify-center text-gray-500 bg-gray-200",class:{ active: _vm.isActive, done: _vm.isDone }},[_vm._v(_vm._s(_vm.number))])}
var staticRenderFns = []

export { render, staticRenderFns }